// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summary-status {
  margin-top: 1.5rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 6px;
}

.summary-status ul {
  margin-top: 0.5rem;
  padding-left: 1.5rem;
}

.summary-status li {
  margin-bottom: 0.25rem;
  color: #666;
}

.summary-controls {
  margin-bottom: 2rem;
}

.available-analyses {
  margin-bottom: 1.5rem;
}

.available-analyses h3 {
  margin-bottom: 1rem;
  color: #333;
  font-size: 1.1rem;
}

.analyses-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 0.75rem;
}

.analysis-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  border-radius: 6px;
  border: 1px solid #dee2e6;
  background-color: white;
}

.analysis-item.completed {
  background-color: #e3f2fd;
  border-color: #1976d2;
}

.analysis-item.pending {
  background-color: #f8f9fa;
  color: #666;
}

.analysis-item .status {
  font-weight: bold;
  font-size: 1.1rem;
}

.analysis-item.completed .status {
  color: #1976d2;
}

.analysis-item.pending .status {
  color: #ccc;
}

.summary-actions {
  display: flex;
  justify-content: center;
  margin: 1.5rem 0;
}

.generate-btn,
.regenerate-btn,
.clear-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  margin: 0 0.5rem;
}

.generate-btn,
.regenerate-btn {
  background-color: #1976d2;
  color: white;
}

.generate-btn:hover:not(:disabled),
.regenerate-btn:hover:not(:disabled) {
  background-color: #1565c0;
}

.generate-btn:disabled,
.regenerate-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.clear-btn {
  background-color: #f8f9fa;
  color: #666;
  border: 1px solid #dee2e6;
}

.clear-btn:hover {
  background-color: #e9ecef;
  color: #333;
}

.action-buttons {
  display: flex;
  gap: 1rem;
}

.executive-summary-result {
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 1.5rem;
  margin-top: 1rem;
}

.summary-header {
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 1rem;
  margin-bottom: 1.5rem;
}

.summary-header h3 {
  margin-bottom: 0.5rem;
  color: #333;
  font-size: 1.25rem;
}

.summary-meta {
  display: flex;
  gap: 2rem;
  font-size: 0.9rem;
  color: #666;
}

.summary-content {
  line-height: 1.6;
  color: #444;
  white-space: pre-wrap;
  margin-bottom: 1.5rem;
}

.executive-summary-result .sources {
  border-top: 1px solid #dee2e6;
  padding-top: 1rem;
}

.executive-summary-result .sources h4 {
  color: #555;
  margin-bottom: 0.5rem;
  font-size: 1rem;
}

.executive-summary-result .sources ul {
  list-style: none;
  padding: 0;
}

.executive-summary-result .sources li {
  padding: 0.25rem 0;
  color: #666;
  font-size: 0.9rem;
}

.executive-summary-result .sources li::before {
  content: "• ";
  color: #1976d2;
  margin-right: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Point1.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;;EAGE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,oBAAoB;AACtB","sourcesContent":[".summary-status {\n  margin-top: 1.5rem;\n  padding: 1rem;\n  background-color: #f8f9fa;\n  border-radius: 6px;\n}\n\n.summary-status ul {\n  margin-top: 0.5rem;\n  padding-left: 1.5rem;\n}\n\n.summary-status li {\n  margin-bottom: 0.25rem;\n  color: #666;\n}\n\n.summary-controls {\n  margin-bottom: 2rem;\n}\n\n.available-analyses {\n  margin-bottom: 1.5rem;\n}\n\n.available-analyses h3 {\n  margin-bottom: 1rem;\n  color: #333;\n  font-size: 1.1rem;\n}\n\n.analyses-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 0.75rem;\n}\n\n.analysis-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem;\n  border-radius: 6px;\n  border: 1px solid #dee2e6;\n  background-color: white;\n}\n\n.analysis-item.completed {\n  background-color: #e3f2fd;\n  border-color: #1976d2;\n}\n\n.analysis-item.pending {\n  background-color: #f8f9fa;\n  color: #666;\n}\n\n.analysis-item .status {\n  font-weight: bold;\n  font-size: 1.1rem;\n}\n\n.analysis-item.completed .status {\n  color: #1976d2;\n}\n\n.analysis-item.pending .status {\n  color: #ccc;\n}\n\n.summary-actions {\n  display: flex;\n  justify-content: center;\n  margin: 1.5rem 0;\n}\n\n.generate-btn,\n.regenerate-btn,\n.clear-btn {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  margin: 0 0.5rem;\n}\n\n.generate-btn,\n.regenerate-btn {\n  background-color: #1976d2;\n  color: white;\n}\n\n.generate-btn:hover:not(:disabled),\n.regenerate-btn:hover:not(:disabled) {\n  background-color: #1565c0;\n}\n\n.generate-btn:disabled,\n.regenerate-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.clear-btn {\n  background-color: #f8f9fa;\n  color: #666;\n  border: 1px solid #dee2e6;\n}\n\n.clear-btn:hover {\n  background-color: #e9ecef;\n  color: #333;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 1rem;\n}\n\n.executive-summary-result {\n  background: white;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  padding: 1.5rem;\n  margin-top: 1rem;\n}\n\n.summary-header {\n  border-bottom: 1px solid #dee2e6;\n  padding-bottom: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.summary-header h3 {\n  margin-bottom: 0.5rem;\n  color: #333;\n  font-size: 1.25rem;\n}\n\n.summary-meta {\n  display: flex;\n  gap: 2rem;\n  font-size: 0.9rem;\n  color: #666;\n}\n\n.summary-content {\n  line-height: 1.6;\n  color: #444;\n  white-space: pre-wrap;\n  margin-bottom: 1.5rem;\n}\n\n.executive-summary-result .sources {\n  border-top: 1px solid #dee2e6;\n  padding-top: 1rem;\n}\n\n.executive-summary-result .sources h4 {\n  color: #555;\n  margin-bottom: 0.5rem;\n  font-size: 1rem;\n}\n\n.executive-summary-result .sources ul {\n  list-style: none;\n  padding: 0;\n}\n\n.executive-summary-result .sources li {\n  padding: 0.25rem 0;\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.executive-summary-result .sources li::before {\n  content: \"• \";\n  color: #1976d2;\n  margin-right: 0.5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
